import {
  createNavigationContainerRef,
  CommonActions,
} from '@react-navigation/native';
import { routes, type RootStackParamList } from '../constants/routes';

export const navigationRef =
  createNavigationContainerRef<RootStackParamList>();

/** Leave role-specific screens and open the dashboard for the active role. */
export function resetToMainTabs(): void {
  if (!navigationRef.isReady()) return;
  navigationRef.dispatch(
    CommonActions.reset({
      index: 0,
      routes: [{ name: routes.mainTabs }],
    }),
  );
}

export function navigateRoot(
  name: keyof RootStackParamList,
  params?: object,
): void {
  if (!navigationRef.isReady()) return;
  navigationRef.dispatch(
    CommonActions.navigate({
      name,
      params,
    }),
  );
}
